__turbopack_context__.v({
  "active": "yarn-preview-card-module__a0L0Mq__active",
  "blok-big-title": "yarn-preview-card-module__a0L0Mq__blok-big-title",
  "blok-subtitle": "yarn-preview-card-module__a0L0Mq__blok-subtitle",
  "blok-title": "yarn-preview-card-module__a0L0Mq__blok-title",
  "dot": "yarn-preview-card-module__a0L0Mq__dot",
  "greenDot": "yarn-preview-card-module__a0L0Mq__greenDot",
  "image": "yarn-preview-card-module__a0L0Mq__image",
  "image-wrapper": "yarn-preview-card-module__a0L0Mq__image-wrapper",
  "outOfStock": "yarn-preview-card-module__a0L0Mq__outOfStock",
  "redDot": "yarn-preview-card-module__a0L0Mq__redDot",
  "tag": "yarn-preview-card-module__a0L0Mq__tag",
  "yarn": "yarn-preview-card-module__a0L0Mq__yarn",
  "yarnSku": "yarn-preview-card-module__a0L0Mq__yarnSku",
});
